<app-picking-productivity-filter (change)="onChangeFilter($event)"
    (changeFilterValues)="onChangeFilterValues($event)"
    [clearFlag]="clearFlag"
    ></app-picking-productivity-filter>
<app-picking-productivity-content [changeFilter]="changeFilter" [searchFilter]="searchFilter">
</app-picking-productivity-content>
<app-footer *ngIf="!isMobile" type="iconsHelpers" [singleOptions]="true" (actionOptions)="onActionOptions()">
</app-footer>